import { Component, ElementRef, Input } from '@angular/core';
import { SupersetService } from './superset.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-superset',
  templateUrl: './superset.component.html',
  styleUrls: ['./superset.component.scss']
})
export class SupersetComponent {
 
  constructor(
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private embedService: SupersetService
  ) {}

  ngOnInit(): void {
    // Escuchar cambios en los parámetros de la URL
    this.route.params.subscribe(params => {
      const id = params['id'];

      if (id) {
        console.log('Nuevo ID detectado en la URL:', id);

        // Actualizar el id del servicio
        this.embedService.id_char = id;

        // Llamar nuevamente al dashboard
        this.embedSupersetDashboard();
      }
    });
  }

  embedSupersetDashboard(): void {
    const dashboardElement = this.elementRef.nativeElement.querySelector('#dashboard');
    if (!dashboardElement) return;

    this.embedService.embedDashboard().subscribe({
      next: () => {
        const iframe = dashboardElement.querySelector('iframe');
        if (iframe) {
          iframe.style.width = '100%';
          iframe.style.height = '100%';
        }
      },
      error: (error) => console.error('Error al incrustar el dashboard:', error)
    });
  }
}
